export const site_id = 15;

export const freshChatWidget = {
    token: "3fc487b1-e083-43e6-9a8d-8a4d42f188fc",
    host: "https://cedcommercechatsupport.freshchat.com",
    widgetUuid: "e8c863b2-f3f0-42f3-8bee-1d8acb5d8a43",
  };
  
